import wsFactory from '@/plugins/websocket/wsfactory';
// import { NetworkType, PublicAccount } from 'nem2-sdk';
import { appConfig } from '../../../config/app.config';

const onAppMount = (EventBus: any): any => {
  const events = {
    CHANGE_SHOW_RECEIVE: 'change-show-receive',
    LOGIN_LISTENER: 'login-listener',
    LOGOUT_LISTENER: 'logout-listener',
    SHOW_ERROR: 'show-error',
  };

  return {
    events,
    register: (app: any): void => {
      EventBus.$on(events.CHANGE_SHOW_RECEIVE, (isShow: boolean) => {
        app.showReceive = isShow;
      });

      EventBus.$on(events.LOGIN_LISTENER, () => {
        if (app.isListenerOpen) {
          const userAccount = {};

          app.initUserListener(userAccount);
        }

        if (!app.claimListenerIsOn) {
          app.claimListenerIsOn = true;
          app.listenToClaim();
        }

        if (app.auth.user.pb) {
          const endpoint = app.$appConfig.endpoints.ws + '?addr=' + app.auth.user.pb;
          wsFactory.open(app, EventBus, endpoint);
        }
      });

      EventBus.$on(events.LOGOUT_LISTENER, () => {
        wsFactory.destroy();
      });

      EventBus.$on(events.SHOW_ERROR, (message: string) => {
        app.errorMessage = message;
        app.showErrorDialog = true;
      });
    }
  };
};

export default onAppMount;
